import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";

const { pathname: tempPathname } = window.location;
const pathname = tempPathname?.toString()?.toLowerCase();

if (pathname.startsWith("/external")) {
  import("./app-external/AppExternal").then(({ default: AppExternal }) => {
    ReactDOM.render(<AppExternal />, document.getElementById("root"));
  });
} else {
  import("./AppInternal").then(({ default: AppInternal }) => {
    ReactDOM.render(<AppInternal />, document.getElementById("root"));
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
